import { applyInfoBlockScale, qtId } from "../../utils/dom";
export const createTimer = (id) => {
    const infoBlock = document.createElement("div");
    infoBlock.id = qtId(id);
    infoBlock.classList.add("qt_infoBlock");
    applyInfoBlockScale(infoBlock);
    l("QTContainer")?.appendChild(infoBlock);
    return infoBlock;
};
